import { call } from 'redux-saga/effects';
import { websocketFetch } from 'common/websocket-redux';

export const getStatementOfAccount = payload =>
  call(websocketFetch, 'get_statement_of_account', payload);
